module.exports = __webpack_public_path__ + "static/17-fe9d008201ae5ff8f15468f74e74dfd9.jpg";